var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('calendarTitle',{attrs:{"data":_vm.data,"callback":function(d) { _vm.callback(d) },"settings":{titlePlaceholder: this.$t('demo.privateTitlePlaceholder')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }